
import Card from 'vux/src/components/card/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {bind} from '@/api/wechat'
import { encrypt } from '@/utils/jsencrypt'
export default {
components: {
Card,
XInput,
Toast,
XButton,
Divider
},
name: 'bind-user',
data() {
return {
username: '',
password: '',
flag: false
}
},
mounted: function () {

},
methods: {
async bindUser(){

const wechatuid = localStorage.getItem('wechatuid')
const params = {
username: this.username,
password: this.password,
id: wechatuid
};
bind(params).then(response => {
this.$vux.toast.show({
text: '绑定成功',
time: 3000,
onShow() {
},
onHide() {
}
})
}).catch(error => {
console.log(error, "loginSub error");
this.$vux.toast.show({
type: 'warn',
text: '绑定失败'
})
});
}
}
}



// WEBPACK FOOTER //
// ./src/components/bind-user.vue